export default {
  "content": "<rect width=\"48\" height=\"48\" rx=\"24\" fill=\"#4141A2\"/><g clip-path=\"url(#clip0_4965_1191)\" fill=\"#fff\"><path d=\"M17.75 34h-2.5c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25zM25.25 34h-2.5c-.69 0-1.25-.56-1.25-1.25v-17.5c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v17.5c0 .69-.56 1.25-1.25 1.25zM32.75 34h-2.5c-.69 0-1.25-.56-1.25-1.25V19c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25v13.75c0 .69-.56 1.25-1.25 1.25z\"/></g><defs><clipPath id=\"clip0_4965_1191\"><path fill=\"#fff\" transform=\"translate(14 14)\" d=\"M0 0h20v20H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};